package com.exura.util
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier

fun Modifier.lineClamp(lines: Int): Modifier = styleModifier {
    property("display", "-webkit-box")
    property("-webkit-box-orient", "vertical")
    property("-webkit-line-clamp", lines)
    property("overflow", "hidden")
}
